
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const MastermindPage = lazy(() => import('../pages/mastermind/page'));
const CoachingPage = lazy(() => import('../pages/coaching/page'));
const JoinMastermindPage = lazy(() => import('../pages/join-mastermind/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mastermind',
    element: <MastermindPage />,
  },
  {
    path: '/coaching',
    element: <CoachingPage />,
  },
  {
    path: '/join-mastermind',
    element: <JoinMastermindPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
